/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PatchPrebidConflictType {
  UnexpectedState = 'unexpected_state',
  CreditLimitExceeded = 'credit_limit_exceeded',
  BidderHasAcceptedPrebidOnLot = 'bidder_has_accepted_prebid_on_lot',
  LotNotOpen = 'lot_not_open'
}
